/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* Creations of Christ: small mobile layout fixes.
   1) Product rows on phones snap one product at a time. The theme's default is loose
      snapping, which lets a swipe stop between two products.
   2) Wide collection banners (like the 3-photo "shop by room" strips) show the whole
      strip on phones instead of being cropped to 16:9. */
(function () {
  if (document.getElementById('coc-mobile-fixes')) return;
  var css = '@media screen and (max-width: 767px){' +
    '.section--featured-collections items-scroll-paged-navigation [data-items]{scroll-snap-type:x mandatory !important;}' +
    '.section--featured-collections items-scroll-paged-navigation [data-items] > *{scroll-snap-stop:always;}' +
    '.collection__header-media.coc-wide-banner::before{padding-bottom:calc(100% / var(--coc-ratio)) !important;}' +
    '}';
  var s = document.createElement('style');
  s.id = 'coc-mobile-fixes';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);

  function fitWideBanners() {
    document.querySelectorAll('.collection__header-media').forEach(function (m) {
      var img = m.querySelector('img');
      if (!img) return;
      var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
      var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
      if (!w || !h) return;
      var ratio = w / h;
      if (ratio < 2.2) return; // normal photos keep the theme's crop
      m.style.setProperty('--coc-ratio', ratio.toFixed(4));
      m.classList.add('coc-wide-banner');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitWideBanners);
  else fitWideBanners();
  document.addEventListener('shopify:section:load', fitWideBanners);
})();

/* Creations of Christ: auto-playing carousels back off while a visitor is using them.
   - Mouse over the carousel: stops. Starts again once the mouse leaves.
   - Touch / swipe on phones: stops. Starts again 6 seconds after the last touch.
   - Keyboard focus inside: stops until focus leaves.
   Covers the hero slideshow (media-carousel with data-autoplay) and the announcement bar.
   The product rows (Featured collections) have their own controller in section-collection.liquid. */
(function () {
  if (window.__cocCarouselPause) return;
  window.__cocCarouselPause = true;
  var TOUCH_RESUME = 6000;

  function wire(el, stop, start) {
    if (!el || el.__cocPause) return;
    el.__cocPause = true;
    var hovering = false, touching = false, focused = false, timer = null;
    function busy() { return hovering || touching || focused; }
    function hold() { window.clearTimeout(timer); stop(); }
    function release(wait) {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { if (!busy()) start(); }, wait);
    }
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; hold(); } });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; release(400); } });
    el.addEventListener('touchstart', function () { touching = true; hold(); }, { passive: true });
    el.addEventListener('touchend', function () { touching = false; release(TOUCH_RESUME); }, { passive: true });
    el.addEventListener('touchcancel', function () { touching = false; release(TOUCH_RESUME); }, { passive: true });
    el.addEventListener('focusin', function () { focused = true; hold(); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { focused = false; release(TOUCH_RESUME); } });
    el.__cocBusy = busy;
  }

  function wireMediaCarousels(root) {
    (root || document).querySelectorAll('media-carousel[data-autoplay]').forEach(function (el) {
      wire(el, function () { el.stop(); }, function () { el.start(); });
      el.addEventListener('on:media-carousel:init', function () { if (el.__cocBusy && el.__cocBusy()) el.stop(); });
    });
  }

  function wireAnnouncementBars(root) {
    (root || document).querySelectorAll('announcement-bar[autoplay]').forEach(function (el) {
      var target = el.querySelector('.announcement__container') || el;
      wire(target, function () { el.stopAutoplay(); }, function () { if (!el.hasAttribute('popup-open')) el.startAutoplay(); });
    });
  }

  function init(root) {
    if (window.customElements) {
      customElements.whenDefined('media-carousel').then(function () { wireMediaCarousels(root); });
      customElements.whenDefined('announcement-bar').then(function () { wireAnnouncementBars(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();